import { cn } from '@/lib/utils';

interface ViewToggleButtonProps {
  active: boolean;
  disabled?: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

export default function ViewToggleButton({
  active,
  disabled,
  onClick,
  children,
}: ViewToggleButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={cn(
        'rounded-md px-2 py-1 text-xs font-medium transition-colors',
        active
          ? 'text-ctu-text underline decoration-2 underline-offset-4'
          : 'text-ctu-text-muted hover:text-ctu-text',
        disabled && 'cursor-not-allowed opacity-40 hover:text-ctu-text-muted',
      )}
    >
      {children}
    </button>
  );
}
